module.exports = __webpack_public_path__ + "img/Logo-Vse.-Zaimi.30cd443b.png";